import React from "react";
import { Route, Routes } from "react-router-dom";
import { authRoutes } from "./authRoutes";
import Dashboard from "features/dashboard/screens/Dashboard";
import ChangePassword from "features/auth/screens/authenticate/ChangePassword";
import ChangePasswordOtp from "features/auth/screens/authenticate/ChangePasswordOTP";
import ContactAicc from "features/help-support/screens/ContactAicc";
import UserListPage from "features/company-users/screens/UserList";
import DataStreamProcess from "features/datastream/DataStreamProcess";
import NavBarLayout from "components/layout/NavBarLayout";
import AuthLayout from "components/layout/AuthLayout";
import Documents from "components/Documents";
import FieldConfiguration from "components/FieldConfiguration";
import AddField from "components/AddField";
import AddUser from "components/AddUser";
import UploadSchema from "components/UploadSchema";
import ViewCompany from "components/ViewCompany";
import ManageSubscription from "components/ManageSubscription";
import CheckSelectedDataStream from "components/CheckSelectedDataStream";
import { datastreamConfigRoutes } from "./datastreamConfigRoutes";
import { companyUserRoutes } from "./companyUserRoutes";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<NavBarLayout />}>
        {/* All Protected routes goes here */}
        <Route path="/dashboard" element={<Dashboard />} />
        <Route exact path="/document" element={<Documents />} />
        <Route element={<CheckSelectedDataStream />}>
          {datastreamConfigRoutes.map((route, index) => (
            <Route
              key={`datastreamConfigRoute-${index}`}
              path={route.path}
              element={route.element}
            />
          ))}
          {companyUserRoutes.map((route, index) => (
            <Route
              key={`companyUserRoute-${index}`}
              path={route.path}
              element={route.element}
            />
          ))}
        </Route>
        <Route
          exact
          path="/datastream/field-config"
          element={<FieldConfiguration />}
        />
        <Route
          exact
          path="/datastream/processing"
          element={<DataStreamProcess />}
        />
        {/* <Route exact path="/user-list" element={<UserList />} /> */}
        <Route path="/add-field" element={<AddField />} />
        <Route path="/add-user" element={<AddUser />} />
        <Route path="/upload-schema" element={<UploadSchema />} />
        <Route path="/view-company/view" element={<ViewCompany />} />
        <Route
          path="/view-company/subscription"
          element={<ManageSubscription />}
        />
        <Route path="/help-me/contact" element={<ContactAicc />} />
        <Route path="/user-list" element={<UserListPage />} />
        <Route
          path="/change-password-otp-page"
          element={<ChangePasswordOtp />}
        />
        <Route path="/change-password-reset" element={<ChangePassword />} />
      </Route>
      <Route element={<AuthLayout />}>
        {authRoutes.map((route, index) => (
          <Route
            key={`auth-${index}`}
            path={route.path}
            element={route.element}
          />
        ))}
      </Route>
    </Routes>
  );
}

export default AppRoutes;
